import React from "react";
import {
  Profile,
  Education,
  WorkExperience,
  UnrelatedWorkExperience,
  LaboratorySkills,
  Projects,
  Contact,
} from "./components";

function App() {
  return (
    <div className="min-h-screen bg-background font-montserrat">
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <Profile />
        <Education />
        <WorkExperience />
        <UnrelatedWorkExperience />
        <LaboratorySkills />
        <Projects />
        <Contact />
        <div className="mt-10 text-center text-sm text-gray-500">
          <p>© {new Date().getFullYear()} All Rights Reserved</p>
          <p>
            Made by{" "}
            <a
              href="https://furkanozturk.nl/"
              className="text-primary hover:underline"
            >
              Furkan Öztürk
            </a>
          </p>
        </div>
      </main>
    </div>
  );
}

export default App;
